import styled from 'styled'
import inputStyle from 'components/Input/styled-input'

const StyledTextArea = styled.textarea`
  ${inputStyle}
  min-height: 150px;
`

export default StyledTextArea;
